/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FooterNoLoginAliases {
  AVATAR_ADDRESS = 'avatar-address',
  AVATAR_CONTACT = 'avatar-contact',
  FOOTER_0 = 'footer-0',
  IMAGE_FOOTER = 'image-footer',
  LINK_0 = 'link-0',
  LINK_COOKIES = 'link-cookies',
  LINK_VERSION = 'link-version',
  PANEL_3 = 'panel-3',
  PANEL_4 = 'panel-4',
  PANEL_5 = 'panel-5',
  PANEL_6 = 'panel-6',
  PANEL_8 = 'panel-8',
  SOCIAL_NETWORKS = 'social-networks',
}
export { FooterNoLoginAliases };
